import React from 'react';
import styles from '~/src/lib/styles.json';
import ChannelSocial from './ChannelSocial';
// import { container } from './AboutChannel.module.css';
import './AboutChannel.scss';

const AboutChannel = ({ channel }) => (
	<div
		className={'AboutChannel'}
		style={{
			display: 'grid',
			gridTemplateColumns: '1fr',
			alignItems: 'center',
			borderBottom: `1px solid ${styles.COLOR.DESATURATED_BLACK_BORDER}`,
		}}
	>
		<h3
			style={{
				fontSize: '14px',
				display: 'flex',
				flexDirection: 'row',
				alignItems: 'center',
			}}
		>
			<img
				style={{
					borderRadius: '50%',
					border: '1px solid #efefef',
					width: '70px',
					height: '70px',
					marginRight: styles.SIZE.GAP,
				}}
				alt={channel.name}
				src={`https://images.overtime.tv/channels/${channel.logo_path}?width=210`}
			/>
			{channel.label}
		</h3>
		<div
			className="desktop-only"
			style={{
				display: 'block',
				color: styles.COLOR.BRAND_PRIMARY,
				textAlign: 'center',
				fontSize: '14px',
			}}
		>
			{channel.topic}
		</div>
		<div
			className="desktop-only"
			style={{
				display: 'flex',
				paddingLeft: styles.SIZE.GAP_2X,
			}}
		>
			<ChannelSocial channel={channel} color={styles.COLOR.BRAND_PRIMARY} />
		</div>
	</div>
);

export default AboutChannel;
